import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import process from 'process';
import jwt_decode from 'jwt-decode';
import { UserRole, UserStatus } from '../../../util/user';
import { setCookie } from 'react-use-cookie';
import { SurveyResponse } from '../../../components/Survey/types';

export const TOKEN_KEY = 'token';

export type Ticket = {
  sub: number;
  exp: number;
  firstName: string;
  lastName: string;
  role: string;
  aud: string;
  access_token: string;
}
export type User = {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;
  surveyResponsesCount: number;
  surveyResponses: SurveyResponse[] | undefined;
}

export type Token = {
  sub: number;
  iat: number;
  exp: number;
  aud: string;
  firstName: string;
  lastName: string;
  role: UserRole;
}

export const isExpired = (token: string) => {
  const decodedToken: Token = jwt_decode(token);
  const currentDate = new Date();
  return (decodedToken.exp * 1000) < currentDate.getTime();
}

export const getUserIdFromToken = (token: string): number => {
  const decodedToken: Token = jwt_decode(token);
  return decodedToken.sub;
}

export const isDev = (): boolean => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
}

interface initialStateType {
  details: null | User;
  loading: boolean;
}

const initialState: initialStateType = {
  details: null,
  loading: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.details = action.payload;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    logout: () => {
      setCookie(TOKEN_KEY, '', { days: 0 });
      window.location.reload();
    },
    clear: () => initialState,
  },
})

export const { actions, reducer } = userSlice;
